<template>
  <a
    v-if="isNewWindow"
    class="app-link"
    :class="[fontColor]"
    :href="path"
    target="_blank"
  >
    {{ label }}
    <font-awesome-icon icon="external-link-alt" />
  </a>
  <router-link
    v-else
    class="app-link"
    :class="[fontColor]"
    :to="path"
  >
    {{ label }}
  </router-link>
</template>

<script>
export default {
  name: 'Link',
  data () {
    return {}
  },
  props: {
    label: String,
    path: String,
    color: String,
    isNewWindow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fontColor: function () {
      switch(this.color) {
        case 'grey': return 'fColorGrey';
        case 'nav': return 'fColorNavigation';
        default: return 'fColorHighlight';
      }
    }
  }
}
</script>

<style scoped>
.app-link {
  text-decoration: none;
  margin: 0;
}
.app-link:hover {
  opacity: 0.75;
}
</style>
